var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var _a;
import { AiReportFormMutationTypes } from '@/types/ai-report-form';
export var state = function () { return ({
    selectedIds: [],
    viewLargeProcess: true
}); };
export var getters = {
    selectedIds: function (state) {
        return state.selectedIds;
    },
    viewLargeProcess: function (state) {
        return state.viewLargeProcess;
    }
};
export var mutations = (_a = {},
    _a[AiReportFormMutationTypes.INIT_STATE] = function (state, payload) {
        Object.assign(state, payload);
    },
    _a[AiReportFormMutationTypes.ADD_IDS] = function (state, payload) {
        var selected = __spreadArrays(state.selectedIds);
        payload.forEach(function (id) {
            if (!selected.includes(id)) {
                selected.push(id);
            }
        });
        state.selectedIds = selected;
    },
    _a[AiReportFormMutationTypes.REMOVE_IDS] = function (state, payload) {
        state.selectedIds = __spreadArrays(state.selectedIds).filter(function (id) { return !payload.includes(id); });
    },
    _a);
export var actions = {
    initState: function (_a) {
        var commit = _a.commit;
        commit(AiReportFormMutationTypes.INIT_STATE, state());
    },
    addIds: function (_a, payload) {
        var commit = _a.commit;
        commit(AiReportFormMutationTypes.ADD_IDS, payload);
    },
    removeIds: function (_a, payload) {
        var commit = _a.commit;
        commit(AiReportFormMutationTypes.REMOVE_IDS, payload);
    }
};
